import { contactItem } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 border border-primary-200/60 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-send-plane-line text-sm"></i>
            投稿联系
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">{contactItem.title}</h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">{contactItem.desc}</p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {contactItem.methods.map((method, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-lg border border-background-200/70 p-5 hover:border-primary-200/70 transition-colors duration-300"
              >
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100/80 flex items-center justify-center">
                  <i className={`${method.icon} text-xl text-accent-600`}></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">{method.label}</div>
                <div className="text-sm font-semibold text-foreground-800 break-all">{method.value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}